export class TokenParams {
    token: string;
    tokenExpireDate: string;
    refreshToken: string;
    refreshTokenExpireDate: string;
}
